var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangle16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13391 2.995L2.21691 11.5C2.12914 11.652 2.08294 11.8245 2.08294 12C2.08294 12.1755 2.12914 12.348 2.21691 12.5C2.30467 12.652 2.43091 12.7782 2.58292 12.866C2.73494 12.9538 2.90738 13 3.08291 13H12.9169C13.0924 13 13.2649 12.9538 13.4169 12.866C13.5689 12.7782 13.6952 12.652 13.7829 12.5C13.8707 12.348 13.9169 12.1755 13.9169 12C13.9169 11.8245 13.8707 11.652 13.7829 11.5L8.86591 2.995C8.77814 2.84299 8.6519 2.71677 8.49989 2.62901C8.34788 2.54125 8.17544 2.49504 7.99991 2.49504C7.82438 2.49504 7.65195 2.54125 7.49993 2.62901C7.34792 2.71677 7.22168 2.84299 7.13391 2.995ZM10.1639 2.244C9.20191 0.579001 6.79791 0.579001 5.83491 2.244L0.917912 10.749C-0.0450881 12.415 1.15791 14.5 3.08291 14.5H12.9169C14.8419 14.5 16.0449 12.415 15.0809 10.749L10.1639 2.244Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle16);
export default __webpack_public_path__ + "static/media/Triangle16.1df0422e58930857a7c260b8f756b566.svg";
export { ForwardRef as ReactComponent };